<template lang="">
  <div>
    <div class='menu':style="{'borderColor':color}" @click='showPopup = true'></div>
    <van-popup v-model="showPopup" position="right" :style="{ width: '50%',height:'100%' }">
      <span @click='goBaiHua' :data-txt="$t('header.baihuaAward')" class='baihua-m'>{{ $t("header.baihuaTitle") }}</span>
      <span @click='rechargeApp'>{{$t("header.nav2")}}</span>
<!--      <span @click='rechargeVip'>会员购买</span>-->
      <span><a  href="/live-all.html">{{$t("header.live")}}</a></span>
      <span><a  href="/topic-all.html">{{$t("header.topic")}}</a></span>
      <span> <a target='_blank' :href="goLinkUrl['Trade'][goLinkeKey]">{{$t("headerOptions")[1].children[0].label}}</a></span>
      <span> <a  href="/les-app.html">{{ $t("home.appProfile") }}</a></span>
      <span> <a  href="/about-us.html">{{$t("header.nav5")}}</a></span>
      <span><a target='_blank' :href="goLinkUrl['invite'][goLinkeKey]">{{ $t("mobleTxt.t1") }}</a></span>
      <span><a target='_blank' :href="goLinkUrl['sign'][goLinkeKey]">{{$t("headerOptions")[0].children[2].label}}</a></span>
      <span><a target='_blank' :href="goLinkUrl['management'][goLinkeKey]">{{$t("headerOptions")[1].children[1].label}}</a></span>
<!--      <span><a target='_blank' href="goLinkUrl['non_contract_anchor_withdraw'][goLinkeKey]">提现</a></span>-->
      <span><a target='_blank'
          href="https://www.sobot.com/chat/pc/index.html?sysNum=4717b63070614a289c61072945a75770">{{ $t("header.ContactUs")}}</a></span>
    </van-popup>
  </div>
</template>
<script>
  import Vue from "vue";
  import { Popup } from 'vant';
  import Util from 'Common/util';
  import constans from 'Constans';
  Vue.use(Popup);

  const goLinkUrl = constans.UrlLink.goLink.menu;
  const goLinkeKey = constans.UrlLink.getUrlKey();

  export default {
    name: 'myMenu',
    props:{
      color: {
        type: String,
        default: '#fff'
      },
    },
    data() {
      return {
        showPopup: false,
        langWindow: Util.getLang(),
        goLinkUrl: constans.UrlLink.goLink.header,
        goLinkeKey: goLinkeKey,
      }
    },
    created(){
      if(document.documentElement.clientWidth < 960){
        if(this.langWindow =='cn'){
          this.$i18n.locale = 'zh'
        }else if(this.langWindow =='tw'){
          this.$i18n.locale = 'zh-f'
        }else{
          this.$i18n.locale = 'en'
        }
      }
    },
    methods: {
      // 充值
      rechargeApp() {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          // window.location.href = 'http://wx.lespark.cn/wx/buy_diamonds'
          window.location.href = goLinkUrl['wx_buy_diamonds'][goLinkeKey]
        } else {
          // window.location.href = 'http://api.lespark.cn/pay_web_order'
          window.location.href = goLinkUrl['rechargeApp'][goLinkeKey]
        }
      },
      // VIP
      rechargeVip() {
        // window.location.href = 'http://api.lespark.cn/pay_web_order?tab=vip'
        window.location.href = goLinkUrl['rechargeVip'][goLinkeKey]
      },
      goBaiHua(){
        // window.location.href = 'http://api.lespark.cn/baihua/index?fromPage=pc'
        window.location.href = goLinkUrl['goBaiHua'][goLinkeKey]
      }
    },
  }
</script>
<style lang="" scoped>
  .menu {
    position: fixed;
    right: 6vw;
    top: 4.5333vw;
    width: 4.8vw;
    height: 2.6667vw;
    box-sizing: border-box;
    border-bottom: 0.8vw solid #fff;
    border-top: 0.8vw solid #fff;
    z-index: 9;
  }

  .van-popup {
    /*van-popupdisplay: flex;*/
    /*flex-direction: column;*/
    /*justify-content: flex-start;*/
    /*align-items: center;*/
  }

  .van-popup>span {
    margin-top: 8vw;
    margin-left: 6.93vw;
    font-size: 4vw;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: block;
    text-align: left;
    position: relative;
  }

  .van-popup>span:active:before{
    content: '';
    width: 50.93vw;
    height: 11.73vw;
    background: #F0F0F0;
    position: absolute;
    left: -6.93vw;
    top:-2.4vw;
    z-index: -1;
  }

  .van-popup>span>a {
    color: #333333;
    display: block;
  }

  .baihua-m{
    position: relative;
  }

  .baihua-m:after{
    content: attr(data-txt);
    position: absolute;
    min-width: 13.87vw;
    height: 5.73vw;
    background: url("https://static.lespark.cn/pc_img/images/baihua/baihua-label.png");
    background-size: 100% 100%;
    font-size: 2.93vw;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 4.6vw;
    text-align: center;
    left: 4.8vw;
    top: -4.93vw;
    padding: 0 1.6vw;
  }

</style>



// WEBPACK FOOTER //
// src/views/components/menu.vue